import AppLayout from "../../components/Layout";
import { Button, Card, Table, TableColumnsType, Tabs } from "antd";
import PreIntervention from "./PreIntervention";
import LabelText from "../../components/LabelText";
import DailyIntervention from "./DailyIntervention";
import { getSummaryPreIntervention, postDashboardSummaryUpdate, SummaryUpdatePayload } from "../../services/adminController";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { formatRupee } from "../../utils";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { AddPhonebookModal } from "../Campaign/component/AddPhonebookModal";
import UpdateSummaryModal from "./PreIntervention/Modal";

const Analytics = () => {
  const lenderData = useParams();
  const [isManuallyEnabled, setIsManuallyEnabled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

 const { lenderId } = useParams<{ lenderId: string }>();
const queryClient = useQueryClient();
if (!lenderId) {
  throw new Error("lenderId is missing in route params");
}


  const { data, isLoading, isError } = useQuery({
    queryKey: ["summaryPreIntervention", lenderId],
    queryFn: () => getSummaryPreIntervention(lenderId || ""),
    // staleTime: 5 * 60 * 1000, // optional: 5 min cache
  });

 const summary_Data = isError ? {} : data?.data || {};
const isFirstTimeUpload = !summary_Data?.lastUpdated;

const nextUploadDate = summary_Data?.lastUpdated
  ? new Date(
      new Date(summary_Data.lastUpdated).setDate(
        new Date(summary_Data.lastUpdated).getDate() + 30
      )
    )
  : null;

const today = new Date();

const isDateEligible = nextUploadDate
  ? today >= nextUploadDate
  : false;

const isAlreadyUploaded = summary_Data?.isPreInterventionUploaded;

const canUploadExcel =
  isFirstTimeUpload ||
  (isDateEligible && !isAlreadyUploaded) ||
  isManuallyEnabled;
                    

  const items = [
    {
      label: "Pre Intervention Analysis",
      key: "1",
      children: <PreIntervention 
         canUploadExcel={canUploadExcel}
        onUploadSuccess={() => setIsManuallyEnabled(false)}
      />
    },
    {
      label: "Daily Intervention Analysis",
      key: "2",
      children: <DailyIntervention />
    },
  ];

   const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

const { mutateAsync } = useMutation({
  mutationFn: (payload: SummaryUpdatePayload) =>
    postDashboardSummaryUpdate(lenderId, payload),
    onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: ["summaryPreIntervention", lenderId],
    });
  },
});

const handleSubmitSummary = async (values: SummaryUpdatePayload) => {
  try {
    await mutateAsync(values);
    setIsModalOpen(false);
  } catch (error) {
    console.error(error);
  }
};

const modalInitialData: any= {
  monthTillDate: summary_Data?.monthTillDate,
  target: summary_Data?.targetAmount,
  totalBorrower: summary_Data?.preInteBorrowerCount,
  totalOutstanding: summary_Data?.preInteOSAmount,
};

  return (
    <AppLayout >
      <Card title="Summary" className="my-5" >
        <div className="grid grid-cols-3 gap-4">
          <LabelText label="Lender Name" text={summary_Data?.lenderName ?? "NA"} />
                <LabelText label="Last Updated Date (Pre-Intervention)" text={summary_Data?.lastUpdated
            ? new Date(summary_Data.lastUpdated).toLocaleString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true, // for AM/PM format
              timeZone: "Asia/Kolkata"
            })
            : "NA"}
          />
            <div className="flex justify-between">
                <LabelText
  label="Pre-Intervention Re-Upload Date"
  text={
    summary_Data?.lastUpdated
      ? new Date(
          new Date(summary_Data.lastUpdated).setDate(
            new Date(summary_Data.lastUpdated).getDate() + 30
          )
        ).toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        
        })
      : "NA"
  }
/>


              </div>
          <LabelText label="Total Borrowers (All Time)" text={summary_Data?.totalBorrowerCount ?? "NA"} />
          <LabelText label="Total Original Principal (All Time)" text={formatRupee(summary_Data?.totalLoanAmount) ?? "NA"} />
          <LabelText label="Total Outstanding  (All Time)" text={formatRupee(summary_Data?.totalOSAmount) ?? "NA"} />
          <LabelText label="Total Outstanding (Pre-Intervention)" text={formatRupee(summary_Data?.preInteOSAmount) ?? "NA"} />
          <LabelText label="Total Pre-Intervention Borrowers" text={summary_Data?.preInteBorrowerCount ?? "NA"} />
            <LabelText label="Month-to-Date (MTD) Collection" text={formatRupee(summary_Data?.mtdTotal) ?? "NA"} />
        <LabelText label="Monthly Target Amount" text={formatRupee(summary_Data?.targetAmount) ?? "NA"} />
        <div/>
         <div className="flex justify-between items-end">
        
          <Button
  type="primary"
  className="ml-1"
 
          onClick={handleOpenModal}
>
  Update Target Amount
</Button>
<Button
  type="primary"
  className="ml-1"
  disabled={canUploadExcel}
  onClick={() => setIsManuallyEnabled(true)}
>
  Enable Upload
</Button>
         </div>
         
           <UpdateSummaryModal
  open={isModalOpen}
  onCancel={handleCloseModal}
  initialData={modalInitialData}
  onSubmit={handleSubmitSummary}
/>

          {/* <LabelText label="Status" text="NA" /> */}
        </div>
      </Card>
      <Tabs items={items}></Tabs>
    </AppLayout>
  );
};

export default Analytics;